import {
  DeviceTitleCell,
  DeviceChargeCell,
  DeviceDetailsCell,
  DeviceEventCell,
  DeviceQRCell,
  DeviceTemperatureCell
} from './device';

export const deviceTableHeadMap = {
  name: DeviceTitleCell,
  battery: DeviceChargeCell,
  temperature: DeviceTemperatureCell,
  event: DeviceEventCell,
  details: DeviceDetailsCell,
  qrcode: DeviceQRCell
};
